<template>
    <v-menu offset-y left class="sr-dropdown">
        <template #activator="{ on: menu }">
            <v-tooltip bottom>
                <template #activator="{ on: tooltip }">
                    <button class="btn-icon icon-user" v-on="{ ...tooltip, ...menu }">
                        <v-avatar size="40px">
                            <img v-show="getUserProfileImage" :src="getUserProfileImage"/>
                        </v-avatar>
                    </button>
                </template>
                <span>Profil</span>
            </v-tooltip>
        </template>
        <v-list v-if="menu">
            <v-list-item
                    v-for="(item, index) in menu"
                    :key="index"
                    @click="$emit('click', item)"
            >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
  export default {
    props: {
      user: {
        type: Object,
        required: true
      },
      menu: Array
    },
    data () {
      return {}
    },
    computed: {
      getUserProfileImage () {
        return this.user.avatar.value && this.user.avatar.value.length ? this.user.avatar.value[0].url : null
      }
    }
  }
</script>

<style scoped>

</style>
